import { useEffect, useState } from "react";

import { useNavigate, useRoutes, type RouteObject } from "react-router-dom";
import { adminRoutes, routes } from "router";
import { ConfigProvider, Spin } from "antd";
import { useRouter } from "hooks/useRouter";
import { userStore } from "store/userStore";
import { observer } from "mobx-react";
import { settings } from "settings";
import { permissionStore } from "store/permissionStore";
import { viVNLocale } from "utils/locale";
import { initUUID } from "utils/device";
import { initOneSignal } from "utils/oneSignal";

const App = observer(() => {
  const element = useRoutes(routes as RouteObject[]);
  const navigate = useNavigate();
  const [isLoaded, setIsLoaded] = useState(false);
  useRouter(isLoaded);

  useEffect(() => {
    initUUID();
    handleInit();
    initOneSignal();
  }, []);

  const handleInit = async () => {
    try {
      if (userStore.token) {
        await userStore.getProfile();
        permissionStore.accessRoutes = [...adminRoutes];
        if (settings.checkPermission && userStore.info.role) {
          await permissionStore.fetchPermissions(userStore.info.role.id);
          permissionStore.setAccessRoutes();
        }
      }
    } catch (error: any) {
      if (error?.response?.status === 401) {
        userStore.logout();
      } else if (userStore.token) {
        navigate("/connection-error");
      }
    } finally {
      setIsLoaded(true);
    }
  };

  return (
    <ConfigProvider
      locale={viVNLocale}
      theme={{
        token: {
          colorPrimary: "#1fa6aa",
          controlOutline: "transparent",
          controlOutlineWidth: 0,
        },
        components: {
          Select: {
            activeBorderColor: "#1fa6aa",
            activeOutlineColor: "transparent",
          },
          Input: {
            activeBorderColor: "#1fa6aa",
            hoverBorderColor: "#1fa6aa",
          },
          Checkbox: {
            colorPrimary: "#1fa6aa",
            colorPrimaryHover: "#1b9296",
          },
        },
      }}
    >
      {isLoaded ? (
        <div className="App app-ant-design-system">{element}</div>
      ) : (
        <div
          className="loading"
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minHeight: "100vh",
          }}
        >
          <Spin size="large" />
        </div>
      )}
    </ConfigProvider>
  );
});

export default App;
